import { IncomeItem, IncomeType } from "shared/types";
import { CombinedIncomeSubStep } from "../../constants";

export enum DocumentType {
  Paystub = "paystub",
  W2 = "w2",
  BankStatement = "bank_statement",
  HousingAssistance = "housing_assistance",
  BenefitsStatement = "benefits_statement"
}

export interface CombinedIncomeStepData {
  lastStep?: CombinedIncomeSubStep;
  currentDocumentType?: DocumentType | null;
  currentIncomeType?: IncomeType | null;
  currentIncomeId?: number | null;
  company_name?: string;
  job_title?: string;
  start_date?: string;
  supervisor?: {
    first_name: string;
    last_name: string;
    contact_email: string;
    contact_phone: string;
  };
  description?: string;
  paid_from?: string;
  pay_period?: string;
  amount?: string;
}

export type CreateIncomePayload = Omit<IncomeItem, "id" | "status">;

export interface NavigationData {
  hasIncome?: boolean;
  incomeType?: IncomeType | null;
}

type FlowCondition = {
  condition: (data?: NavigationData) => boolean;
  target: CombinedIncomeSubStep;
};

export type FlowStep = {
  next?: CombinedIncomeSubStep | FlowCondition[];
  back?: CombinedIncomeSubStep | FlowCondition[];
};
